import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BusinessService } from 'src/app/services/business.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { CreateCompanyComponent } from '../create-company/create-company.component';
import { UpdateBusinessComponent } from '../config/business/update-business/update-business.component';

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss']
})
export class BusinessComponent {

  business: any[] = [];
  profile!: any;
  searchText!: string;
  now: Date = new Date();

  displayedColumns: string[] = ['actions', 'name', 'cif', 'address', 'fee', 'created', 'open'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  @ViewChild(MatSort) sort: MatSort = new MatSort;
  sorted!: any;

  page = 1;

  urlImages: string = AppSettings.MEDIA_URI;
  @Output() changeTag: EventEmitter<any> = new EventEmitter<any>();
  loaded: boolean = false;
  loadingPage: boolean = true;

  finishScroll: boolean = false;
  @ViewChild('containerScroll', { static: false }) containerScroll: ElementRef;
  private searchTerms = new Subject<string>();
  private businessRequest?: Subscription;
  private loadGeneration = 0;

  companySelect!: any;

  constructor(private dialog: MatDialog, private router: Router,
    private auth: AuthenticationService, private apiBusiness: ApiBusinessService) { }

  ngOnInit(): void {
    // const dialogRef = this.dialog.open(CreateCompanyComponent, {
    //   data: {}
    // });

    this.profile = this.auth.getProfile();
    this.now.setHours(0);
    this.now.setMinutes(0);
    this.companySelect = JSON.parse(localStorage.getItem('business') || '{}');
    this.getData();
  }

  ngAfterViewInit() {
    this.searchTerms.pipe(
      debounceTime(500), // Espera 300ms después de cada pulsación de tecla
      distinctUntilChanged(), // Ignora si el nuevo término de búsqueda es igual al anterior
    ).subscribe(items => {
      this.searchText = items;
      this.updateBusiness();
    });
  }

  getData() {
    const generation = this.loadGeneration;
    this.businessRequest = this.apiBusiness.getAllBusinessAdmin(this.page, this.searchText, this.sorted).subscribe({
      next: (res) => {
        if (generation !== this.loadGeneration) return;
        if (res.data.data.length < 15) {
          this.finishScroll = true;
        }
        this.business = this.business.concat(res.data.data);

        this.dataSource = new MatTableDataSource(this.business);
        this.dataSource.sort = this.sort;

        this.loaded = true;
        this.loadingPage = false;
      }
    })
  }

  updateBusiness() {
    this.businessRequest?.unsubscribe();
    this.loadGeneration++;
    this.page = 1;
    this.loadingPage = true;
    this.finishScroll = false;
    this.business = [];
    this.getData();
  }

  searchBusiness(event) {
    this.searchTerms.next(event);
  }

  openBusiness(item: any) {
    // const url = this.draft ? 'events/draft' : 'events';
    // if (this.idVenue) {
    //   const urlFront = AppSettings.FRONT + '/panel-control/' + url + '/detail/info-event/' + event[0].id;
    //   window.open(urlFront, '_blank');
    // } else {
    //   this.router.navigate(['/panel-control/' + url + '/detail/info-event', event[0].id]);
    // }
  }

  // Sort
  sortData(sort: Sort) {
    if (this.business.length > 1) {
      const isAsc = (sort.direction === 'asc') ? 'asc' : 'desc';
      if (sort.direction) {
        this.sorted = { sortedBy: sort.active, sort: isAsc };
      } else {
        this.sorted = null;
      }
      this.updateBusiness();
    }
  }

  /**
   * Comisión de taquilla del organizador. Se edita desde aquí y no desde la
   * configuración de la organización porque es un acuerdo comercial de Citylok:
   * el propio organizador no debe poder cambiarse lo que se le cobra.
   */
  editTicketOfficeFee(company: any) {
    const dialogRef = this.dialog.open(UpdateBusinessComponent, {
      panelClass: 'update-business-dialog',
      data: {
        id: company.id,
        name: 'Comisión de taquilla',
        valueChange: 'ticket_office_fee',
        value: company,
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res?.status === 'changed') {
        company.ticket_office_fee = res.value?.ticket_office_fee ?? company.ticket_office_fee;
      } else if (res?.status === 'error') {
        this.openInfoCard(res.msg);
      }
    });
  }

  openInfoCard(msg: string, disabledClose: boolean = false) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        text: msg
      }
    });
  }

  //Pagination
  @HostListener('window:scroll', ['$event'])
  @HostListener('scroll', ['$event'])
  public isScrolledInfinityView(event: any): void {
    if (!this.loadingPage) {
      if (!this.finishScroll) {
        const element = this.containerScroll.nativeElement.getBoundingClientRect();
        let bottomShown = element.bottom <= window.innerHeight;
        if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
          bottomShown = true;
        }
        if (bottomShown && !this.finishScroll) {
          this.page++;
          this.loadingPage = true;
          setTimeout(() => {
            this.getData();
          }, 200);
        }
        // }
      } else {
        this.finishScroll = false;
      }
    }
  }

  enterLikeCompany(company: any) {
    this.companySelect = company;
    this.apiBusiness.setBusinessSuperAdmin(company);
    this.router.navigate(['/panel-control/orders']);
  }

  openCreateCompany() {
    const dialogRef = this.dialog.open(CreateCompanyComponent, {
      width: '1100px',
      maxWidth: '95vw'
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result) {
          this.apiBusiness.setBusinessSuperAdmin(result);
          this.apiBusiness.setBusinessStorage(result);
          this.router.navigate(['/panel-control/config/business/info-business']);
        }
      }
    })
  }

  getImageUrl(imageUrl: string): string {
    if (!imageUrl) return '';
    if (imageUrl.startsWith('http')) {
      return imageUrl;
    }

    // Remover slash inicial si existe y prepend companies_images/
    let processedUrl = imageUrl.startsWith('/') ? imageUrl.substring(1) : imageUrl;
    processedUrl = 'companies_images/' + processedUrl;

    // Asegurar que haya exactamente un slash entre urlImages y processedUrl
    const baseEndsWithSlash = this.urlImages.endsWith('/');
    const pathStartsWithSlash = processedUrl.startsWith('/');

    if (baseEndsWithSlash && pathStartsWithSlash) {
      // Ambos tienen slash, remover uno
      return this.urlImages + processedUrl.substring(1);
    } else if (!baseEndsWithSlash && !pathStartsWithSlash) {
      // Ninguno tiene slash, agregar uno
      return this.urlImages + '/' + processedUrl;
    } else {
      // Uno tiene slash, concatenar directamente
      return this.urlImages + processedUrl;
    }
  }
}
